
import React from 'react';

type BlogSearchBarProps = {
  searchQuery: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  filteredPosts: any[];
  onClearSearch?: () => void;
};

const BlogSearchBar: React.FC<BlogSearchBarProps> = ({ 
  searchQuery, 
  onSearchChange, 
  filteredPosts,
  onClearSearch 
}) => {
  return (
    <div className="max-w-xl mx-auto mb-12">
      <div className="relative">
        <input
          type="search"
          value={searchQuery}
          onChange={onSearchChange}
          placeholder="Search blog posts..."
          className="w-full border border-gray-300 rounded-lg px-4 py-3 pr-12 focus:outline-none focus:ring-2 focus:ring-[#C46829] focus:border-[#C46829]"
          aria-label="Search blog posts"
        />
        <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400">
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            className="h-5 w-5" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor" 
            aria-hidden="true"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>
      </div>
      
      {searchQuery && (
        <div className="mt-2 text-sm">
          {filteredPosts.length === 0 ? (
            <p className="text-gray-500">No posts found matching "{searchQuery}"</p>
          ) : (
            <p className="text-gray-600">Found {filteredPosts.length} post{filteredPosts.length !== 1 ? 's' : ''} matching "{searchQuery}"</p>
          )}
        </div>
      )}
    </div>
  );
};

export default BlogSearchBar;
